<template>
  <b-row align-h="start" class="stats-card">
    <b-col class="d-flex flex-row align-items-center mb-2" cols="4" lg="3">
      <b-avatar variant="light">
        <fa-icon icon="phone-volume" />
      </b-avatar>
      <div class="d-flex flex-column ml-1">
        <small>Звонки:</small>
        <strong v-if="stats">{{ stats.calls }}</strong>
      </div>
    </b-col>
    <b-col class="d-flex flex-row align-items-center mb-2" cols="4" lg="3">
      <b-avatar variant="light">
        <fa-icon icon="arrow-right" />
      </b-avatar>
      <div class="d-flex flex-column ml-1">
        <small>Входящие:</small>
        <strong v-if="stats">{{ stats.incoming }}</strong>
      </div>
    </b-col>
    <b-col class="d-flex flex-row align-items-center mb-2" cols="4" lg="3">
      <b-avatar variant="light">
        <fa-icon icon="arrow-left" />
      </b-avatar>
      <div class="d-flex flex-column ml-1">
        <small>Исходящие:</small>
        <strong v-if="stats">{{ stats.outgoing }}</strong>
      </div>
    </b-col>
    <b-col class="d-flex flex-row align-items-center mb-2" cols="4" lg="3">
      <b-avatar variant="light">
        <fa-icon icon="dot-circle" />
      </b-avatar>
      <div class="d-flex flex-column ml-1">
        <small>Call-tracking:</small>
        <strong v-if="stats">{{ stats.tracking_calls }}</strong>
      </div>
    </b-col>
    <b-col class="d-flex flex-row align-items-center mb-2" cols="4" lg="3">
      <b-avatar variant="light">
        <fa-icon icon="chart-pie" />
      </b-avatar>
      <div class="d-flex flex-column ml-1">
        <small>Доля трекинга:</small>
        <strong v-if="stats">{{ (stats.tracking_share * 100).toFixed(2) }}%</strong>
      </div>
    </b-col>
    <b-col class="d-flex flex-row align-items-center mb-2" cols="4" lg="3">
      <b-avatar variant="light">
        <fa-icon icon="phone-volume" />
      </b-avatar>
      <div class="d-flex flex-column ml-1">
        <small>Номера трекинга:</small>
        <strong v-if="stats">{{ stats.tracking_phones }}</strong>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
    name: 'ShortStats',
    props: ['stats']
};
</script>
